import styled from "styled-components";

export const Container = styled.div`
    width:100%;
    display: flex;
    align-items: center;
    justify-content:center;
    flex-direction: column;
`;

export const Img = styled.img`

    width:max(5vw, 50px);
    opacity:0.8;
    margin-bottom:2vh;

`;